import axios from 'axios';
import TagManager from 'react-gtm-module';
import { sha256 } from 'js-sha256';
import { LiferayLoginConfig62 } from './config.constants';
import { GTMFormatDate, GTMRemoveAccents, Md5HashCode } from './hashes';
import { loginDataLayer } from './dataLayer';

export const loginLiferay = async (token: string, decoded: any) => {
  console.log('🚀 ~ loginLiferay ~ token:', token);
  const JWT_COOKIE_NAME = process.env.REACT_APP_TOKEN_NAME || 'session-token';
  console.log('🚀 ~ loginLiferay ~ JWT_COOKIE_NAME:', JWT_COOKIE_NAME);

  const alreadyLogged = token === localStorage.getItem(JWT_COOKIE_NAME);
  console.log('🚀 ~ loginLiferay ~ alreadyLogged:', alreadyLogged);
  const hasToLoginOnLF =
    token &&
    !alreadyLogged &&
    (decoded['https://smiles.api/memberStatus'] === 'ACTIVE' ||
      decoded['https://smiles.api/memberStatus'] === 'INCOMPL. REGISTRATION PARTNER' ||
      decoded['https://smiles.api/memberStatus'] === 'PENDING ENROLLMENT' ||
      decoded['https://smiles.api/memberStatus'] === 'REGISTRATION IN ANALYSIS');
  console.log('🚀 ~ loginLiferay ~ hasToLoginOnLF:', hasToLoginOnLF);

  if (hasToLoginOnLF && !window.location.origin.includes('localhost')) {
    try {
      const resp = await axios.get(
        `https://${window.location.hostname}/${LiferayLoginConfig62.LOGIN_ACTION}&token=${token}`,
      );
      console.log('🚀 ~ loginLiferay ~ resp:', resp);

      if (resp.data.status !== LiferayLoginConfig62.SESSION_CREATED) {
        localStorage.removeItem(JWT_COOKIE_NAME);
        sessionStorage.removeItem(JWT_COOKIE_NAME);
        window.location.replace(`/logout?returnTo=${window.location.origin}/validar/erro`);
        return true;
      }

      localStorage.setItem(JWT_COOKIE_NAME, token);
      sessionStorage.setItem(JWT_COOKIE_NAME, token);
      loginDataLayer.triggerEvent();
      saveNotificationConfig(resp.data.notificationConfig);
      saveLightboxConfig(resp.data.lightboxConfig);
      executeGTM(resp.data.member);
      return false;
    } catch (e) {
      localStorage.removeItem(JWT_COOKIE_NAME);
      sessionStorage.removeItem(JWT_COOKIE_NAME);
      window.location.replace(`/logout?returnTo=${window.location.origin}/validar/erro`);
      return true;
    }
  }
  return false;
};

const saveNotificationConfig = (notificationConfig: any) => {
  if (notificationConfig) {
    localStorage.setItem('notificationConfig', JSON.stringify(notificationConfig));
  } else {
    localStorage.removeItem('notificationConfig');
  }
};

const saveLightboxConfig = (lightboxConfig: any) => {
  if (lightboxConfig) {
    sessionStorage.setItem('lightboxConfig', JSON.stringify(lightboxConfig));
  } else {
    sessionStorage.removeItem('lightboxConfig');
  }
};

const executeGTM = (member: any) => {
  try {
    const memberObjs = {
      memberNumber: Md5HashCode(member.memberNumber),
      memberNumberNotHash: member.memberNumber,
      clubMember: member.clubMember,
      startDate: GTMFormatDate(new Date(member.startDate)),
      citizenship: member.citizenship,
      language: member.language,
      emailAddress: Md5HashCode(member.emailAddress),
      emailAddressSecondary: Md5HashCode(member.emailAddressSecondary),
      emailSha256: sha256(member.emailAddress),
      availableMiles: member.availableMiles,
      gender: member.gender,
      mgmMember: member.mgmMember,
      status: member.status,
      milesNextExpirationDate: GTMFormatDate(new Date(member.milesNextExpirationDate)),
      birthDay: GTMFormatDate(new Date(member.birthDay)),
      category: member.category,
      state: member.state,
      country: GTMRemoveAccents(member.country),
      city: GTMRemoveAccents(member.city),
      milesToExpire: member.milesToExpire,
    };

    const tagManagerArgs = {
      dataLayer: memberObjs,
    };
    TagManager.dataLayer(tagManagerArgs);

    const tagManagerEvtArgs = {
      dataLayer: {
        event: 'smlLogin',
      },
    };
    TagManager.dataLayer(tagManagerEvtArgs);
  } catch (e) {
    console.error(`GTM Error: ${e}`);
  }
};
